import { createAction } from '@reduxjs/toolkit'

export const expireSession = createAction('auth/session/expire')
